<div class="header">
    <h2>{{ 'media.modal.view.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="all-media-view-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

@if (loading() !== false) {
    <div class="loading">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (error()) {
    <app-unavailable [message]="'media.error.unavailable' | translate" />
} @else if (media(); as media) {
    <div class="body">
        <div class="entity-header">
            <div class="entity-identity">
                <h1>{{ media.name }}</h1>
                <app-type-chip [type]="media.type" translationPrefix="media.type" />
            </div>
        </div>

        <div class="preview">
            @switch (media.type) {
                @case ('image') {
                    <app-media-image [mediaId]="media.id" [alt]="media.name" />
                }
                @case ('video') {
                    <app-media-video [mediaId]="media.id" />
                }
                @case ('audio') {
                    <app-media-audio [mediaId]="media.id" />
                }
                @case ('pdf') {
                    <app-media-pdf [mediaId]="media.id" />
                }
                @case ('text') {
                    <app-media-text [mediaId]="media.id" />
                }
            }
        </div>

        <div class="section">
            <h2>{{ 'media.fieldset.details' | translate }}</h2>
            <div class="row">
                <div class="field">
                    <span class="label">{{ 'media.form.name' | translate }}</span>
                    <span class="value">{{ media.name || '-' }}</span>
                </div>
                <div class="field">
                    <span class="label">{{ 'media.form.type' | translate }}</span>
                    <app-type-chip [type]="media.type" translationPrefix="media.type" />
                </div>
            </div>

            @if (media.type !== 'text') {
                <div class="row">
                    <div class="field">
                        <span class="label">{{ 'media.detail.fileName' | translate }}</span>
                        <span class="value mono truncate" [title]="media.fileName">{{ media.fileName || '-' }}</span>
                    </div>
                    <div class="field">
                        <span class="label">{{ 'media.detail.size' | translate }}</span>
                        <span class="value">{{ media.size || '-' }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="field">
                        <span class="label">{{ 'media.detail.mimeType' | translate }}</span>
                        <span class="value mono">{{ media.mimeType || '-' }}</span>
                    </div>
                    <div class="field">
                        <span class="label">{{ 'media.detail.createdAt' | translate }}</span>
                        <span class="value">{{ media.createdAt | date: 'medium' }}</span>
                    </div>
                </div>
            } @else {
                <div class="row">
                    <div class="field">
                        <span class="label">{{ 'media.form.duration' | translate }}</span>
                        <span class="value">{{ media.duration ?? '-' }}</span>
                    </div>
                    <div class="field">
                        <span class="label">{{ 'media.detail.createdAt' | translate }}</span>
                        <span class="value">{{ media.createdAt | date: 'medium' }}</span>
                    </div>
                </div>
            }
        </div>
    </div>

    <div class="footer">
        <app-delete-button [mediaId]="media.id" [saving]="saving()" testId="all-media-view-delete" />
        <p-button [label]="'media.detail.edit' | translate" icon="pi pi-pencil" data-test="all-media-view-edit" (onClick)="onEdit()" />
    </div>
}
